import { Controller } from "@hotwired/stimulus"

// Flash messages take themselves back off the screen.
//
// Two rules keep this from being an accessibility problem. The timer stops
// while somebody is reading: hovering the message, or tabbing into its close
// button, pauses it and leaving starts it again. And a message that reports a
// problem gets twice as long as one that confirms something, because "der er
// ikke flere pladser, sig til personalet" takes more reading than "tak".
//
// The close button is there so nobody has to wait out either.
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.start()
  }

  disconnect() {
    this.clear()
  }

  start() {
    this.clear()
    if (this.delayValue > 0) this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  pause() {
    this.clear()
  }

  resume() {
    this.start()
  }

  dismiss() {
    this.clear()

    if (this.reducedMotion) return this.element.remove()

    // The fade is a courtesy, not a dependency: if the transition never fires
    // the message still goes.
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    setTimeout(() => this.element.remove(), 600)
    this.element.classList.add("opacity-0")
  }

  get reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  clear() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = null
  }
}
